import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './offer-list.scss';

import { DeviceContext, deviceType } from '@providers';

import DesktopProductListSkeleton from '@src/componentsNew/Skeleton/desktop/components/DesktopProductListSkeleton';
import MobileProductListSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileProductListSkeleton';

import { UI_COMPONENT } from '@queries';
import { uiComponent, uiComponent_uicomponent_items } from '@src/queries/__generated__/uiComponent';

import { goToUrl } from '@src/utils/urlCheck';
import { gaV4ClickOffer } from '@utils';
import { offersUrl } from '@src/app/routes';

interface IProps {
  maxItem?: number;
  isFindMoreOffers: boolean;
  uiComponentVariable: {
    name: string;
    desktopSize: string;
    mobileSize: string;
  };
}

const OfferList = ({ maxItem = 9999, isFindMoreOffers, uiComponentVariable }: IProps) => {
  const history = useHistory();
  const { isMobile } = React.useContext<deviceType>(DeviceContext);

  const [offerItems, setOfferItems] = useState<uiComponent_uicomponent_items[]>([]);

  const { data, loading } = useQuery<uiComponent>(UI_COMPONENT, {
    variables: uiComponentVariable,
    onCompleted: (data) => {
      const offers = data?.uicomponent?.items;

      if (offers?.length) {
        const activeOffers = offers.filter((offer) => offer?.isActive).slice(0, maxItem);

        setOfferItems(activeOffers);
      }
    },
  });

  const onClickOfferItem = async (offer: uiComponent_uicomponent_items) => {
    goToUrl(history, offer.link);

    await gaV4ClickOffer(offer.title ?? '');
  };

  if (loading) {
    return isMobile ? (
      <MobileProductListSkeleton type="image" />
    ) : (
      <DesktopProductListSkeleton type="image" count={6} />
    );
  }

  return offerItems.length ? (
    <div id="offer-list-wrapper">
      {offerItems.map((offer, idx) => (
        <div
          key={idx}
          className={`image-wrapper ${isMobile ? 'mobile' : 'desktop'}`}
          onClick={() => onClickOfferItem(offer)}
        >
          {isMobile ? (
            <LazyLoadImage src={offer.imageMobileUrl} alt={offer.name} effect="blur" />
          ) : (
            <LazyLoadImage src={offer.imageWebUrl} alt={offer.name} effect="blur" />
          )}
        </div>
      ))}
      {isFindMoreOffers && (
        <div className="more-offer-link">
          <Link to={offersUrl}>Find more offers</Link>
        </div>
      )}
    </div>
  ) : null;
};

export default OfferList;
